import { render, staticRenderFns } from "./EditPasswordCard.vue?vue&type=template&id=794f17e3&"
import script from "./EditPasswordCard.vue?vue&type=script&lang=js&"
export * from "./EditPasswordCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports